














import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import ApiAccessBase from '../components/ApiAccessBase.vue';

@Component
export default class SystemError extends ApiAccessBase {
}
